/**
 * aaa-contact-click.js
 * ---------------------------------------------------------------------------
 * Site-wide tap tracking for phone and email links. Loaded from
 * snippets/scripts.liquid. One delegated listener; nothing to add to sections.
 *
 * Also: a click on any link to renteo.ie publishes `renteo_click`
 *   { target: '<renteo URL, no query>', text, path }.
 * (The Renteo availability search form publishes `renteo_search` itself,
 * from snippets/aaa-renteo-booking.liquid.)
 *
 * On a click of any a[href^="tel:"] or a[href^="mailto:"] it publishes the
 * Shopify web-pixel custom event `contact_click`:
 *   { channel: 'phone'|'email', target: '<number or address>',
 *     text: '<link text>', path: '/current/path' }
 * The target is the business's own number/address (never visitor data).
 * A Custom Pixel forwards it to GA4 as `contact_click`.
 *
 * Fires on the click, before the OS hands off to the dialler/mail app; the
 * publish is a postMessage into the pixel sandbox, so it does not delay or
 * block the navigation and needs no preventDefault.
 */
(function () {
  if (window.__aaaContactClickBound) return;
  window.__aaaContactClickBound = true;

  function publish(name, data) {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try { window.Shopify.analytics.publish(name, data); } catch { /* never block the storefront */ }
    }
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href^="tel:"], a[href^="mailto:"], a[href*="renteo.ie"]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.indexOf('renteo.ie') !== -1) {
      publish('renteo_click', {
        target: href.split('?')[0].slice(0, 200),
        text: (a.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80),
        path: location.pathname
      });
      return;
    }
    var isTel = href.indexOf('tel:') === 0;
    var target = decodeURIComponent(href.replace(/^(tel:|mailto:)/, '').split('?')[0]).replace(/\s+/g, '');
    publish('contact_click', {
      channel: isTel ? 'phone' : 'email',
      target: target,
      text: (a.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80),
      path: location.pathname
    });
  }, true);
})();
